import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
	selector: '[auto]',
})
export class AutoFocus implements AfterViewInit {
	constructor(private elementRef: ElementRef) {}

	ngAfterViewInit() {
		const elem = this.elementRef.nativeElement;
		elem.focus();
	}
}
